import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          // APEX M4 — Design System V2 : toasts au langage WM (blanc bordé
          // stone, texte charcoal, sharp, ombre canonique).
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-charcoal group-[.toaster]:border-stone group-[.toaster]:shadow-elevated group-[.toaster]:rounded-none",
          title: "group-[.toast]:text-[13px] group-[.toast]:font-medium",
          description: "group-[.toast]:text-graphite group-[.toast]:text-xs",
          actionButton:
            "group-[.toast]:bg-charcoal group-[.toast]:text-ivory group-[.toast]:rounded-none group-[.toast]:uppercase group-[.toast]:text-[10px] group-[.toast]:tracking-[0.12em]",
          cancelButton:
            "group-[.toast]:bg-white group-[.toast]:border group-[.toast]:border-stone group-[.toast]:text-graphite group-[.toast]:rounded-none",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
